/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFTechSource = {
    Asm: 'asm',
    Firehose: 'firehose',
    External: 'external'
} as const;
export type CRSFTechSource = typeof CRSFTechSource[keyof typeof CRSFTechSource];


export function CRSFTechSourceFromJSON(json: any): CRSFTechSource {
    return CRSFTechSourceFromJSONTyped(json, false);
}

export function CRSFTechSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTechSource {
    return json as CRSFTechSource;
}

export function CRSFTechSourceToJSON(value?: CRSFTechSource | null): any {
    return value as any;
}

